export const CSS_CLASSES = {
  FORM_FIELD_ROOT: "form-field",

  FORM_FIELD_TOP_ROW: "form-field-top-row",
  LABEL_ONLY: "label-only",
  SECONDARY_ACTION_ONLY: "secondary-action-only",

  FORM_FIELD_LABEL: "form-field-label",
  FORM_FIELD_LABEL_REQUIRED_INDICATOR: "form-field-label-required-indicator",
  FORM_FIELD_LABEL_TEXT: "form-field-label-text",
  FORM_FIELD_LABEL_INFO: "form-field-label-info",

  FORM_FIELD_BOTTOM_ROW: "form-field-bottom-row",
  MESSAGE_ONLY: "message-only",
  TEXT_LENGTH_INDICATOR_ONLY: "text-length-indicator-only",

  FORM_FIELD_MESSAGE: "form-field-message",

  FORM_FIELD_TEXT_LENGTH_INDICATOR: "form-field-text-length-indicator",
};
